import React from 'react';
import queryString from 'qs';
import _ from 'lodash';
import { compose } from 'recompose';
import axios from 'axios';

import {
  Divider,
  Segment,
  Grid,
  Icon,
  Label,
} from 'semantic-ui-react';
import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();

const logoStyle = {
  display: 'block',
  margin: '50px auto 30px auto',
  maxWidth: '100%',
};

const RegisterThanks = () => {
  console.log(window.location.search);
  if (theme.tokenThanksRedirectUrl) {
    console.log('TokenThanks', theme.tokenThanksRedirectUrl);
    window.location = theme.tokenThanksRedirectUrl;
  }

  const qs = window.location.search;
  const parsed = queryString.parse(_.replace(qs, '?', ''));
  const { name, email, handle } = parsed;


  const payload = {
    data: {
      profile: {
        name,
        email,
        handle,
      },
      qs,
    },
  };
  const client = axios.create({
    baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/notifyaccess2',
    timeout: 2000,
    headers: {
      Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg',
    },
  });

  client.post('/', payload).catch(err => console.log(err.message));

  return (
    <div className="page">
      <div className="page-content">
        <div style={{ backgroundColor: 'red', width: '90%', margin: 'auto', borderRadius: '10px' }}>
          <a href="/"><img style={logoStyle} src="https://caffeinebullet.com/cdn/shop/files/Caffeine-Bullet-Landscape-White-Logo.png?v=1694455373" alt={theme.darkLogo.alt} /></a>
        </div>
        <Grid container>
          <Grid.Row>
            <Grid.Column only="computer" computer="3" />
            <Grid.Column computer="10" mobile="16">
              <Segment textAlign="center" size="">
                {!theme.tokenThanksMessage &&
                (<h1 style={{ textAlign: 'center' }}>
                  { name && <div>Hi {name}!</div> }
                Thanks for getting back to us!
                </h1>) }
                <br />
                <p>We can't wait to get started...</p>
                <p>We will send out an email (to the address below) with your free gift code in the next couple of days.</p>
                <br />
                <p><Label basic color="red">{email}</Label></p>
                <br />
                <p>Please keep an eye out for emails from <strong>caffeinebullet@shopfluence.app</strong>.</p>


                {theme.tokenThanksMessage &&
                (<h1 style={{ textAlign: 'center' }}>
                  {theme.tokenThanksMessage}
                </h1>) }
                {!theme.tokenThanksMessage && <Divider />}
                {!theme.tokenThanksMessage &&
                  <div>
                    <p className="info">Our support team will be in touch if there are any issues.</p>
                    <br />
                    <p className="info">Or you can get in touch by email at <Icon name="at" color="red" /><a href="mailto:caffeinebullet@shopfluence.app">caffeinebullet@shopfluence.app</a></p>
                  </div>
                }
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Column only="computer" computer="3" />
        </Grid>
      </div>
    </div>
  );
};


export default compose()(RegisterThanks);



/** WEBPACK FOOTER **
 ** ./src/components/register-thanks/index.js
 **/